<template>
  <div class="mobile">
    <div class="fullbox">
      <div class="form">
        <div class="from_title">
          <div class="left">编号: {{ userinfo.id }}</div>
          <div class="right">
            <div class="top_state top_state1" v-if="userinfo.state == 1">
              未归还
            </div>
            <div class="top_state top_state2" v-if="userinfo.state == 2">
              已归还
            </div>
            <div class="top_state top_state3" v-if="userinfo.state == 3">
              异常
            </div>
          </div>
        </div>
        <div class="filed_box">
          <div class="filed">
            <div class="filed_label"><span></span>申请人员</div>
            <div class="filed_value">{{ userinfo.empName }}</div>
          </div>
          <div class="filed">
            <div class="filed_label"><span></span>所属部门</div>
            <div class="filed_value">{{ userinfo.department }}</div>
          </div>
          <div class="filed">
            <div class="filed_label"><span></span>联系电话</div>
            <div class="filed_value">{{ userinfo.phone }}</div>
          </div>
          <div class="filed">
            <div class="filed_label"><span></span>所属区域</div>
            <div class="filed_value">{{ userinfo.place }}</div>
          </div>
          <div class="filed">
            <div class="filed_label"><span></span>借伞数量</div>
            <div class="filed_value">{{ userinfo.num }}</div>
          </div>
          <div class="filed">
            <div class="filed_label"><span></span>借用时间</div>
            <div class="filed_value">{{ userinfo.buTime }}</div>
          </div>
          <div class="filed">
            <div class="filed_label"><span></span>预计归还时间</div>
            <div class="filed_value">{{ userinfo.planTime }}</div>
          </div>
        </div>
        <div class="from_text">
          <div class="left">
            <div class="label">已归还数量</div>
            <div class="value">{{ userinfo.returnNum }}</div>
          </div>
          <div class="right">
            <div class="label">剩余未归还数量</div>
            <div class="value">
              {{ userinfo.num - userinfo.returnNum - userinfo.errorNum }}
            </div>
          </div>
        </div>
      </div>
      <div v-if="historyList.length > 0">
        <div
          class="form"
          v-for="item in historyList"
          :key="item.id"
          style="margin-top: 18px"
        >
          <div
            class="from_title"
            style="border-bottom: none; padding-bottom: 0"
          >
            <div class="left"></div>
            <div class="right">
              <div class="top_state top_state1" v-if="item.state == 1">
                待确认
              </div>
              <div class="top_state top_state2" v-if="item.state == 2">
                已确认
              </div>
              <div class="top_state top_state3" v-if="item.state == 3">
                驳回
              </div>
            </div>
          </div>
          <div class="filed_box">
            <div class="filed">
              <div class="filed_label"><span></span>ID号</div>
              <div class="filed_value">{{ item.buRecordId }}</div>
            </div>
            <div class="filed">
              <div class="filed_label"><span></span>归还数量</div>
              <div class="filed_value">{{ item.num }}</div>
            </div>
            <div class="filed">
              <div class="filed_label"><span></span>异常记录</div>
              <div class="filed_value" v-if="item.damageNum || item.loseNum">
                丢失:{{ item.loseNum }}&emsp;损坏:{{ item.damageNum }}
              </div>
              <div class="filed_value" v-else>--</div>
            </div>
            <div class="filed">
              <div class="filed_label"><span></span>归还时间</div>
              <div class="filed_value">{{ item.backTime }}</div>
            </div>
            <div class="filed">
              <div class="filed_label"><span></span>备注</div>
              <div class="filed_value">{{ item.remark }}</div>
            </div>
            <div class="filed">
              <div class="filed_label"><span></span>确认人</div>
              <div class="filed_value">{{ item.disposeName }}</div>
            </div>
            <div class="filed">
              <div class="filed_label"><span></span>确认时间</div>
              <div class="filed_value">{{ item.disposeTime }}</div>
            </div>
          </div>
          <div class="footer_btn" v-if="item.state == 1">
            <div @click="reject(item)">驳回</div>
            <div @click="confirm(item)">确认</div>
          </div>
        </div>
      </div>
    </div>
    <van-dialog
      v-model="showSignIn"
      :show-cancel-button="false"
      :showConfirmButton="false"
      title="提示"
    >
      <div class="dialog_header_con">您是否确认通过？</div>
      <div class="dialog_footer1">
        <el-button @click="showSignIn = false">取消</el-button>
        <el-button @click="submit">确认</el-button>
      </div>
    </van-dialog>
    <van-dialog
      v-model="showSignOut"
      :show-cancel-button="false"
      :showConfirmButton="false"
      title="提示"
    >
      <!-- <div class="dialog_header_con">您是否确认驳回？</div> -->
      <div class="dialog_header_inp">
        <van-field
          v-model="message"
          rows="3"
          label="驳回理由"
          type="textarea"
          placeholder="请输入留言"
          label-width="70px"
        />
      </div>
      <div class="dialog_footer1">
        <el-button @click="showSignOut = false">取消</el-button>
        <el-button @click="noReject">确认</el-button>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import moment from "moment";
import apis from "@/apis/borrowingAnUmbrella";
import { getToken } from "@/utils/cookie";
export default {
  components: {},
  data() {
    return {
      userinfo: {},
      historyList: [],
      id: "",
      showSignIn: false,
      showSignOut: false,
      message: "",
    };
  },
  mounted() {
    const { id } = this.$route.query;
    this.id = id;
    this.getList();
    this.getUserList();
  },
  methods: {
    // 驳回
    reject(item) {
      this.itemObject = item;
      this.showSignOut = true;
    },
    // 确认
    confirm(item) {
      this.itemObject = item;
      this.showSignIn = true;
    },
    // 确认通过
    submit() {
      const params = {
        id: this.itemObject.id,
        state: 2,
        empNo: getToken(),
      };
      apis.confirmReturn(params).then(() => {
        this.$message({
          message: "确认成功",
          type: "success",
        });
        this.showSignIn = false;
        this.getList();
      });
    },
    // 驳回确认
    noReject() {
      if (!this.message) return this.$message.error("请输入驳回理由");
      const params = {
        id: this.itemObject.id,
        state: 3,
        empNo: getToken(),
        reason: this.message,
      };
      apis.confirmReturn(params).then(() => {
        this.$message({
          message: "驳回成功",
          type: "success",
        });
        this.message = "";
        this.showSignOut = false;
        this.getList();
      });
    },
    // 获取借伞记录详情
    getUserList() {
      apis.recordDetail({ id: this.id }).then((res) => {
        console.log(res, "res-----");
        this.userinfo = res.data;
        this.userinfo.buTime = this.userinfo.buTime
          ? moment(this.userinfo.buTime).format("YYYY-MM-DD HH:mm")
          : "";
        this.userinfo.planTime = this.userinfo.planTime
          ? moment(this.userinfo.planTime).format("YYYY-MM-DD HH:mm")
          : "";
      });
    },
    // 获取归还记录列表
    getList() {
      const params = {
        buRecordId: this.id,
        state: 0,
      };
      apis.returnList(params).then((res) => {
        console.log(res, "res");
        this.historyList = res.data;
        this.historyList.length > 0 &&
          this.historyList.forEach((item) => {
            item.backTime = item.backTime
              ? moment(item.backTime).format("YYYY-MM-DD HH:mm")
              : "";
            item.disposeTime = item.disposeTime
              ? moment(item.disposeTime).format("YYYY-MM-DD HH:mm")
              : "";
          });
      });
    },
    //返回
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .fullbox {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .fullbox {
    width: 276px * $zoom;
  }
}
.mobile {
  width: 100%;
  display: flex;
  justify-content: center;
}
.fullbox {
  font-size: 14px * $zoom;
  position: relative;
  height: 100vh;
  overflow: auto;
  padding: 30px;
  background: #f7f9fa;
  &::-webkit-scrollbar {
    display: none;
  }
  .form {
    background: #fff;
    border-radius: 30px;
    padding: 20px 30px 30px;
    .from_title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 0 30px;
      border-bottom: 1px solid #e4e6e8;
      .left {
        color: #000;
        font-size: 32px;
      }
      .right {
        .top_state {
          padding: 15px 34px;
          border-radius: 8px;
          font-size: 28px;
        }
        .top_state1 {
          color: #fe964a;
          background: #fff0e6;
        }
        .top_state2 {
          color: #0caf60;
          background: #e7f7ef;
        }
        .top_state3 {
          color: #fd6a6a;
          background: #fff0f0;
        }
      }
    }
    .filed_box {
      border: 1px solid #e4e6e8;
      padding: 15px 30px;
      border-radius: 30px;
      margin-top: 30px;
    }
    .filed {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      padding: 18px 0;
      // line-height: 80px;
      // border-bottom: 1px solid #e4e6e8;
      .filed_label {
        color: #969b9e;
        font-size: 28px;
        margin-right: 50px;
        white-space: nowrap;
        span {
          color: #ff4d4d;
        }
      }
      .filed_value {
        color: #000;
        font-size: 28px;
        text-align: right;
        ::v-deep {
          .textRight {
            .van-field__control {
              text-align: right !important;
            }
          }
        }
        // font-weight: bold;
      }
    }
    .filed2 {
      margin-top: 30px;
      .filed_label {
        color: #969b9e;
        font-size: 28px;
        margin-right: 50px;
        white-space: nowrap;
        span {
          color: #ff4d4d;
        }
      }
      .filed_value {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        margin-top: 20px;
        ::v-deep {
          .el-input-number {
            border-radius: 100px;
            width: 190px;
            .el-input-number__decrease,
            .el-input-number__increase {
              border: none;
              background: none;
              color: #4fa27d;
              line-height: 65px;
              width: 70px;
              i {
                font-size: 30px;
                font-weight: bold;
              }
            }
            .el-input--mini .el-input__inner {
              height: 60px;
              line-height: 60px;
              border-radius: 50px;
            }
          }
          .van-cell {
            padding: 0;
          }
          .textLeft {
            .van-field__control {
              text-align: left;
              border: 1px solid #e4e6e8;
              border-radius: 30px;
              padding: 20px 30px;
            }
          }
        }
        .left {
          margin-top: 10px;
          ::v-deep {
            .van-radio {
              margin-bottom: 30px;
            }
            .van-radio__label {
              font-size: 28px;
            }
            .van-radio__icon--checked .van-icon {
              background: none;
              color: #4fa27d;
              border-radius: 6px;
              border: 2px solid #000;
            }
          }
        }
        .right {
          display: flex;
          align-items: center;
          font-size: 28px;
          color: #969b9e;
        }
      }
    }
    .line {
      width: 100%;
      height: 1px;
      background: #e4e6e8;
      margin: 10px 0;
    }
    .from_text {
      width: 100%;
      background: #4fa27d;
      border-radius: 30px;
      padding: 40px 0;
      display: flex;
      align-items: center;
      font-size: 26px;
      margin-top: 30px;
      color: #fff;
      .left,
      .right {
        width: 50%;
        text-align: center;
        .value {
          font-size: 34px;
          margin-top: 10px;
        }
      }
    }
    .footer_btn {
      display: flex;
      align-content: center;
      justify-content: center;
      margin-top: 30px;
      div {
        padding: 15px 40px;
        font-size: 28px;
      }
      div:nth-child(1) {
        margin-right: 60px;
        color: #282b32;
        border: 1px solid #282b32;
        border-radius: 10px;
      }
      div:nth-child(2) {
        color: #fff;
        background: #4fa27d;
        border-radius: 10px;
      }
    }
  }
  .footer {
    .btn2 {
      border: none;
      background: none;
      color: #969b9e;
      width: 100%;
      height: 85px;
      font-size: 10px * $zoom;
      margin: 0 0 30px !important;
      border-radius: 15px;
    }
    .btn1 {
      background: #4fa27d;
      color: #fff;
      width: 100%;
      height: 85px;
      font-size: 10px * $zoom;
      margin: 50px 0 30px;
      border-radius: 15px;
    }
  }
}

.dialog_header_con {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 25px;
  .left {
    color: #282b32;
    font-size: 30px;
  }
}
.dialog_header_inp {
  ::v-deep {
    .van-field__body {
      background: #ececec;
      border-radius: 20px;
      padding: 20px;
    }
  }
}
.dialog_footer1 {
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin: 30px 0;
  button {
    width: 40%;
    height: 65px;
    font-size: 10px * $zoom;
    border-radius: 15px;
  }
  button:nth-child(1) {
    border: 1px solid #999999;
    background: #fff;
    color: #999999;
  }
  button:nth-child(2) {
    border: 1px solid #4fa27d;
    background: #4fa27d;
    color: #fff;
  }
}
</style>
